module.exports = __webpack_public_path__ + "img/invoiceAudit.d50570f2.png";